import type { CSSProperties } from "react";
import { useRef } from "react";
import { MeterGlitter } from "./MeterGlitter.js";
import { meterPercent } from "./meterWidth.js";

type MeterBarProps = {
  value: number;
  max: number;
  from?: number;
  variant?: "progress" | "hp";
  glitterGain?: number;
};

function reduceMotion(): boolean {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches === true;
}

export function MeterBar({ value, max, from, variant = "progress", glitterGain = 3 }: MeterBarProps) {
  const fillRef = useRef<HTMLSpanElement>(null);
  const toPct = meterPercent(value, max);
  const fromPct = from == null ? toPct : meterPercent(from, max);
  const filling = from != null && fromPct !== toPct;
  const rising = filling && toPct > fromPct && variant === "progress" && !reduceMotion();
  const barClass = ["bar", variant === "hp" ? "is-hp" : ""].filter(Boolean).join(" ");
  const fillStyle = { width: `${toPct}%`, "--meter-from": `${fromPct}%` } as CSSProperties;

  return (
    <div className={rising ? "meter-host is-glitter" : "meter-host"} aria-hidden="true">
      <div className={barClass}>
        <span ref={fillRef} className={filling ? "is-meter-fill" : undefined} style={fillStyle} />
      </div>
      {rising ? <MeterGlitter fillRef={fillRef} gain={glitterGain} /> : null}
    </div>
  );
}
